import Image from '@/components/UI/Image';
import EFArrowUp from '@/components/UI/svg/Icons/EFArrowUp';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import css from './index.module.scss';
import gtm from '@/utils/gtm';
import { saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

gsap.registerPlugin(ScrollTrigger);

const { EFPic } = createEFPic('/media/deltapro/pc/');
export default function Section13() {
    const { useEffect, Link, useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { t: s } = useLang('shared');
    const { locale } = useRouter();

    const shopList2: any = [
        {
            key: 0,
            title: t('delta_pro_extra_battery'),
            imgPath: ['section_2_1.webp', 'section_2_1.png'],
            imgPath2: ['section_2_2.webp', 'section_2_2.png'],
            link:
                locale === 'cn'
                    ? 'https://item.jd.com/10050023721649.html#none'
                    : locale === 'cis'
                    ? 'https://ecoflow-russia.com/products/vneshnyaya-umnaya-batareya-dlya-stantsij-ecoflow-delta-pro'
                    : locale === 'sa'
                    ? 'https://www.amazon.ae/dp/B0B45XT3RW?ref=myi_title_dp'
                    : `https://${locale}.ecoflow.com/products/delta-pro-smart-extra-battery`,
        },
    ];

    if (!['cn', 'cis', 'ph'].includes(locale)) {
        shopList2.push({
            key: 1,
            title: t('smart_generator'),
            imgPath: ['section_1_1.webp', 'section_1_1.png'],
            imgPath2: ['section_1_2.webp', 'section_1_2.png'],
            imgPath3: ['section_1_3.webp', 'section_1_3.png'],
            link: ['us', 'ca'].includes(locale) ? '/dual-fuel-smart-generator' : '/smart-generator',
            config: {
                offsetClass: 'offsetTop',
                width: 300,
                height: 440,
            },
        });
    }

    const handleClick = (link: any) => {
        saveAICookieForShopify(link, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: 'EcoFlow DELTA Pro',
            position: 'In-Product Details Page',
        });
    };
    useEffect(() => {
        /* -start- section13 充电口 动画 */
        const TL = gsap.timeline({
            scrollTrigger: {
                trigger: '.section13',
                start: 'top top',
                end: `+=100%`,
                scrub: 0.2,
            },
        });
        TL.to('.shopList .img_2', {
            opacity: 1,
        });
        TL.to('.shopList .img_3', {
            opacity: 1,
        });

        /* -end- section13 充电口 动画 */
        return () => {
            TL.kill();
        };
    }, []);

    return (
        <div
            className={`${css.section13} GtmModuleData-section`}
            data-section-id={css.section13}
            data-section-title={t.rich('extra_battery_port_sub_title_pc', {
                line1: (child: string) => child,
            })}
        >
            <div className="sec13-sticky-wrapper">
                <div className="sec13-sticky-container">
                    <div className="sec13-content">
                        <h4 className="subTitle font-family-extrabold">
                            <Image src="/media/deltapro/pc/icon/09-extra-battery-port-icon.svg" width={54} height={54} alt="" />
                            <span>{t('extra_battery_port')}</span>
                        </h4>
                        <h2 className="mainTitle font-family-extrabold">
                            {t.rich('extra_battery_port_sub_title_pc', {
                                line1: (child: string) => <strong style={{ color: '#6b60ff' }}>{child}</strong>,
                            })}
                        </h2>
                        <p className="text font-family-semibolder">{t('extra_battery_port_desc')}</p>

                        <ul className="shopList">
                            {shopList2.map((shop: any) => (
                                <li key={shop.key} className="shopItem">
                                    <div className={`img ${shop.config?.offsetClass}`}>
                                        <div
                                            className={`img_1 imgBox`}
                                            style={{ width: shop.config?.width || '340px', height: shop.config?.height || '420px' }}
                                        >
                                            <EFPic name={shop.imgPath} alt="" />
                                        </div>
                                        <div
                                            className={`img_2 imgBox`}
                                            style={{ width: shop.config?.width || '340px', height: shop.config?.height || '420px' }}
                                        >
                                            <EFPic name={shop.imgPath2} alt="" />
                                        </div>
                                        {shop.imgPath3 && (
                                            <div
                                                className={`img_3 imgBox`}
                                                style={{ width: shop.config?.width || '340px', height: shop.config?.height || '420px' }}
                                            >
                                                <EFPic name={shop.imgPath3} alt="" />
                                            </div>
                                        )}
                                    </div>

                                    <h5 className="title font-family-semibolder">{shop.title}</h5>
                                    {(!['br', 'mx'].includes(locale) || shop.key !== 1) && (
                                        <Link
                                            className="GtmModuleData-btn-href"
                                            href={shop.link}
                                            dataLayer={{
                                                __btn_id1: css.section13,
                                                __btn_id2: shop.link,
                                            }}
                                        >
                                            <button className="link font-family-regular" onClick={() => handleClick(shop.link)}>
                                                <span>{s('support.site_support_learn_more')}</span>
                                                <EFArrowUp />
                                            </button>
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
